import confetti from "canvas-confetti";
import * as React from "react";
import CryptoJS from "crypto-js";

export const getLocalData = (item) => {
  const decryptValue = localStorage.getItem(item);
  if (!decryptValue) return null;
  return handleDecrypt(decryptValue);
};

export const setLocalData = (item, value) => {
  const encryptValue = handleEncrypt(value);
  return localStorage.setItem(item, encryptValue);
};

export function replaceAll(string, search, replace) {
  return string.split(search).join(replace);
}

export function compareArrays(arr1, arr2) {
  let words_result = [];

  // Iterate over each element and compare
  for (var k in arr1) {
    if (arr2[k] === "" || arr2[k] === undefined) {
      // Element not available on the same key
      words_result.push("-1");
    } else if (arr1[k] === arr2[k]) {
      // Elements match on the same key
      words_result.push("1");
    } else {
      // Element does not match on the same key
      words_result.push("0");
    }
  }
  if (arr1.length < arr2.length) {
    for (let i = arr1.length; i < arr2.length; i++) {
      words_result.push("-1");
    }
  }
  return words_result;
}

export const questionsList = [
  {
    question:
      "One day, a dog was passing by a river. He had a bone in his mouth.",
    type: "sentence",
  },
  {
    question: "He looked into the water and saw his own reflection in it.",
    type: "sentence",
  },
  {
    question: "He started barking bow-wow, and bone fell into the water.",
    type: "sentence",
  },
  { question: "River", type: "word" },
  { question: "Water", type: "word" },
  { question: "Barking", type: "word" },
  {
    question:
      "There are many different kinds of animals that live in China. Tigers and leopards are animals that live in China's forests in the north.",
    type: "paragraph",
  },
  {
    question:
      "Bali and Lombok are neighbouring islands both are part of the Indonesian archipelago. It is easy to appreciate each island as an attractive tourist destination.",
    type: "paragraph",
  },
  {
    question:
      "Martin Luther led many demonstrations against racism. He delivered his message in a non-violent manner. The jail sentence he received was four months.",
    type: "paragraph",
  },
];

export const NextButtonRound = (props) => {
  return (
    <svg
      width={props.width || 70}
      height={props.height || 70}
      viewBox="0 0 54 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={props?.disabled && 0.3}
    >
      <rect width={54} height={54} rx={27} fill="url(#paint0_linear_81_347)" />
      <path
        d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8"
        fill="white"
        transform="translate(10, 10) scale(2.5)" /* Make arrow bigger and keep it centered */
      />
      <defs>
        <linearGradient
          id="paint0_linear_81_347"
          x1={0}
          y1={27}
          x2={54}
          y2={27}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E15404" />
          <stop offset={1} stopColor="#FF9050" />
        </linearGradient>
      </defs>
    </svg>
  );
};

export const NextButton = (props) => {
  return (
    <svg
      width={121}
      height={54}
      viewBox="0 0 121 54"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      opacity={props?.disabled && 0.3}
    >
      <rect width={121} height={54} rx={10} fill="url(#paint0_linear_81_347)" />
      <path
        d="M32.12 21C32.3867 21 32.6 21.0933 32.76 21.28C32.9333 21.4533 33.02 21.6733 33.02 21.94V33.98C33.02 34.2733 32.92 34.52 32.72 34.72C32.5333 34.9067 32.2933 35 32 35C31.8667 35 31.72 34.9733 31.56 34.92C31.4133 34.8667 31.3 34.7933 31.22 34.7L23 24.04L23.46 23.78V34.08C23.46 34.3333 23.3733 34.5533 23.2 34.74C23.0267 34.9133 22.8067 35 22.54 35C22.26 35 22.0333 34.9133 21.86 34.74C21.7 34.5533 21.62 34.3333 21.62 34.08V22.02C21.62 21.7133 21.72 21.4667 21.92 21.28C22.12 21.0933 22.36 21 22.64 21C22.7867 21 22.94 21.0333 23.1 21.1C23.2733 21.1533 23.4 21.24 23.48 21.36L31.5 31.8L31.2 32.08V21.94C31.2 21.6733 31.2867 21.4533 31.46 21.28C31.6333 21.0933 31.8533 21 32.12 21ZM40.968 35.2C39.8613 35.2 38.9013 34.9733 38.088 34.52C37.2746 34.0533 36.6413 33.42 36.188 32.62C35.748 31.8067 35.528 30.88 35.528 29.84C35.528 28.6667 35.7613 27.6667 36.228 26.84C36.708 26 37.328 25.36 38.088 24.92C38.848 24.4667 39.6546 24.24 40.508 24.24C41.1613 24.24 41.7813 24.3733 42.368 24.64C42.9546 24.8933 43.4746 25.2533 43.928 25.72C44.3946 26.1733 44.7613 26.7133 45.028 27.34C45.2946 27.9533 45.4346 28.6267 45.448 29.36C45.4346 29.6267 45.328 29.8467 45.128 30.02C44.928 30.1933 44.6946 30.28 44.428 30.28H36.648L36.168 28.58H43.688L43.308 28.94V28.44C43.2813 27.9733 43.128 27.5667 42.848 27.22C42.568 26.86 42.2213 26.5867 41.808 26.4C41.3946 26.2 40.9613 26.1 40.508 26.1C40.108 26.1 39.7213 26.1667 39.348 26.3C38.988 26.42 38.6613 26.62 38.368 26.9C38.088 27.18 37.8613 27.5533 37.688 28.02C37.528 28.4733 37.448 29.04 37.448 29.72C37.448 30.4533 37.6013 31.0933 37.908 31.64C38.2146 32.1867 38.628 32.6133 39.148 32.92C39.668 33.2133 40.2413 33.36 40.868 33.36C41.3613 33.36 41.768 33.3133 42.088 33.22C42.408 33.1133 42.6746 32.9867 42.888 32.84C43.1013 32.6933 43.288 32.5533 43.448 32.42C43.648 32.3 43.848 32.24 44.048 32.24C44.288 32.24 44.488 32.3267 44.648 32.5C44.808 32.66 44.888 32.8533 44.888 33.08C44.888 33.3733 44.7413 33.64 44.448 33.88C44.088 34.2267 43.588 34.5333 42.948 34.8C42.3213 35.0667 41.6613 35.2 40.968 35.2ZM47.7095 24.42C48.0429 24.42 48.3162 24.56 48.5295 24.84L55.3495 33.44C55.4962 33.6133 55.5695 33.8133 55.5695 34.04C55.5695 34.3067 55.4629 34.54 55.2495 34.74C55.0362 34.94 54.8029 35.04 54.5495 35.04C54.2295 35.04 53.9562 34.9 53.7295 34.62L46.9095 26.02C46.7629 25.8467 46.6895 25.6467 46.6895 25.42C46.6895 25.14 46.7895 24.9067 46.9895 24.72C47.2029 24.52 47.4429 24.42 47.7095 24.42ZM47.7295 35.04C47.5029 35.04 47.2829 34.9533 47.0695 34.78C46.8562 34.6067 46.7495 34.3933 46.7495 34.14C46.7495 33.9133 46.8295 33.7067 46.9895 33.52L50.1695 29.58L51.1895 31.22L48.5295 34.62C48.3162 34.9 48.0495 35.04 47.7295 35.04ZM54.5295 24.42C54.8095 24.42 55.0362 24.5133 55.2095 24.7C55.3962 24.8733 55.4895 25.08 55.4895 25.32C55.4895 25.4267 55.4695 25.54 55.4295 25.66C55.4029 25.7667 55.3429 25.8667 55.2495 25.96L52.1095 29.9L51.0695 28.42L53.7295 24.88C53.9562 24.5733 54.2229 24.42 54.5295 24.42ZM58.2522 24.6H62.9522C63.2189 24.6 63.4389 24.6933 63.6122 24.88C63.7989 25.0533 63.8922 25.2733 63.8922 25.54C63.8922 25.7933 63.7989 26.0067 63.6122 26.18C63.4389 26.3533 63.2189 26.44 62.9522 26.44H58.2522C57.9855 26.44 57.7589 26.3533 57.5722 26.18C57.3989 25.9933 57.3122 25.7733 57.3122 25.52C57.3122 25.2533 57.3989 25.0333 57.5722 24.86C57.7589 24.6867 57.9855 24.6 58.2522 24.6ZM60.3522 22C60.6455 22 60.8855 22.1 61.0722 22.3C61.2589 22.4867 61.3522 22.7267 61.3522 23.02V32.3C61.3522 32.54 61.3922 32.7333 61.4722 32.88C61.5522 33.0267 61.6589 33.1267 61.7922 33.18C61.9389 33.2333 62.0855 33.26 62.2322 33.26C62.3789 33.26 62.5055 33.2333 62.6122 33.18C62.7322 33.1267 62.8722 33.1 63.0322 33.1C63.1922 33.1 63.3389 33.1733 63.4722 33.32C63.6055 33.4667 63.6722 33.6667 63.6722 33.92C63.6722 34.24 63.4989 34.5 63.1522 34.7C62.8055 34.9 62.4322 35 62.0322 35C61.8055 35 61.5389 34.98 61.2322 34.94C60.9255 34.9 60.6255 34.8 60.3322 34.64C60.0522 34.48 59.8189 34.2267 59.6322 33.88C59.4455 33.52 59.3522 33.02 59.3522 32.38V23.02C59.3522 22.7267 59.4455 22.4867 59.6322 22.3C59.8322 22.1 60.0722 22 60.3522 22Z"
        fill="white"
      />
      <g clipPath="url(#clip0_81_347)">
        <path
          d="M78 25.9993H89.86L86.23 21.6393C86.0603 21.4351 85.9786 21.1718 86.003 20.9074C86.0274 20.6429 86.1558 20.399 86.36 20.2293C86.5642 20.0596 86.8275 19.9779 87.0919 20.0023C87.3563 20.0267 87.6003 20.1551 87.77 20.3593L92.77 26.3593C92.8036 26.407 92.8337 26.4572 92.86 26.5093C92.86 26.5593 92.86 26.5893 92.93 26.6393C92.9753 26.754 92.9991 26.876 93 26.9993C92.9991 27.1226 92.9753 27.2446 92.93 27.3593C92.93 27.4093 92.93 27.4393 92.86 27.4893C92.8337 27.5414 92.8036 27.5916 92.77 27.6393L87.77 33.6393C87.676 33.7522 87.5582 33.843 87.4252 33.9052C87.2921 33.9674 87.1469 33.9995 87 33.9993C86.7663 33.9998 86.5399 33.9184 86.36 33.7693C86.2587 33.6854 86.175 33.5822 86.1137 33.4659C86.0523 33.3496 86.0145 33.2222 86.0025 33.0913C85.9904 32.9603 86.0043 32.8282 86.0433 32.7026C86.0824 32.577 86.1458 32.4603 86.23 32.3593L89.86 27.9993H78C77.7348 27.9993 77.4804 27.8939 77.2929 27.7064C77.1054 27.5189 77 27.2645 77 26.9993C77 26.7341 77.1054 26.4797 77.2929 26.2922C77.4804 26.1047 77.7348 25.9993 78 25.9993Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_81_347"
          x1={121}
          y1={54}
          x2={33.4084}
          y2={20.4058}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#E15404" />
          <stop offset={1} stopColor="#FF9050" />
        </linearGradient>
        <clipPath id="clip0_81_347">
          <rect
            width={24}
            height={24}
            fill="white"
            transform="matrix(-1 0 0 1 97 15)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const ListenButton = (props) => {
  return (
    <svg
      width={props.width || 70}
      height={props.height || 70}
      viewBox="0 0 70 70"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="70"
        height="70"
        rx="35"
        fill="url(#paint0_linear_400_1331)"
      />
      <g clipPath="url(#clip0_400_1331)">
        <path
          d="M43.374 30.1609C43.1512 29.8851 42.828 29.7091 42.4754 29.6716C42.1228 29.6341 41.7698 29.7381 41.494 29.9609C41.2181 30.1837 41.0421 30.5069 41.0046 30.8595C40.9671 31.2121 41.0712 31.5651 41.294 31.8409C41.9676 32.7568 42.3309 33.864 42.3309 35.0009C42.3309 36.1379 41.9676 37.245 41.294 38.1609C41.135 38.3569 41.0349 38.5939 41.0053 38.8445C40.9757 39.095 41.0178 39.3489 41.1267 39.5765C41.2356 39.8041 41.4069 39.9961 41.6206 40.1302C41.8343 40.2644 42.0817 40.3351 42.334 40.3343C42.5332 40.3349 42.73 40.291 42.91 40.2056C43.0899 40.1202 43.2485 39.9956 43.374 39.8409C44.4316 38.449 45.0042 36.749 45.0042 35.0009C45.0042 33.2528 44.4316 31.5528 43.374 30.1609Z"
          fill="white"
        />
        <path
          d="M45.1871 25.9724C45.0522 25.8603 44.8967 25.7759 44.7292 25.724C44.5618 25.6721 44.3857 25.6536 44.2112 25.6697C44.0366 25.6858 43.8669 25.7361 43.7118 25.8178C43.5566 25.8995 43.4191 26.0109 43.3071 26.1457C43.195 26.2806 43.1106 26.4361 43.0587 26.6036C43.0067 26.771 42.9883 26.9471 43.0044 27.1216C43.0205 27.2962 43.0708 27.4659 43.1525 27.621C43.2341 27.7761 43.3456 27.9137 43.4804 28.0257C44.5498 28.8522 45.4208 29.9073 46.0299 31.1139C46.6389 32.3204 46.9705 33.6479 47.0004 34.9991C46.9705 36.3503 46.6389 37.6777 46.0299 38.8842C45.4208 40.0908 44.5498 41.1459 43.4804 41.9724C43.3454 42.0843 43.2338 42.2218 43.152 42.3769C43.0702 42.5321 43.0198 42.7018 43.0037 42.8764C42.9876 43.0511 43.0061 43.2272 43.0581 43.3946C43.1102 43.5621 43.1948 43.7177 43.3071 43.8524C43.4324 44.0029 43.5894 44.1239 43.7669 44.2069C43.9443 44.2899 44.1378 44.3327 44.3337 44.3324C44.6453 44.333 44.9472 44.2245 45.1871 44.0257C46.561 42.9516 47.6766 41.5832 48.4519 40.021C49.2272 38.4589 49.6425 36.7428 49.6671 34.9991C49.6425 33.2553 49.2272 31.5392 48.4519 29.9771C47.6766 28.4149 46.561 27.0465 45.1871 25.9724Z"
          fill="white"
        />
        <path
          d="M38.294 23.1591C38.0913 23.0421 37.8614 22.9805 37.6273 22.9805C37.3933 22.9805 37.1633 23.0421 36.9606 23.1591L28.334 29.0924H21.6673C21.3137 29.0924 20.9746 29.2329 20.7245 29.483C20.4745 29.733 20.334 30.0721 20.334 30.4258V39.5724C20.334 39.9261 20.4745 40.2652 20.7245 40.5152C20.9746 40.7653 21.3137 40.9058 21.6673 40.9058H28.334L36.8806 46.7724C37.1148 46.9239 37.3885 47.0028 37.6673 46.9991C38.0209 46.9991 38.3601 46.8586 38.6101 46.6086C38.8602 46.3585 39.0007 46.0194 39.0007 45.6658V24.3324C39 24.0912 38.9339 23.8547 38.8095 23.6481C38.6851 23.4415 38.5069 23.2725 38.294 23.1591Z"
          fill="white"
        />
      </g>
      <defs>
        <linearGradient
          id="paint0_linear_400_1331"
          x1="70"
          y1="70"
          x2="-9.38217"
          y2="56.914"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#710EDC" />
          <stop offset="1" stopColor="#A856FF" />
        </linearGradient>
        <clipPath id="clip0_400_1331">
          <rect
            width="32"
            height="32"
            fill="white"
            transform="translate(19 19)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const SpeakButton = (props) => (
  <svg
    width={props.width || 70}
    height={props.height || 70}
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={70} height={70} rx={35} fill="url(#paint0_linear_400_1340)" />
    <g clipPath="url(#clip0_400_1340)">
      <path
        d="M35 39.5C36.5913 39.5 38.1174 38.8679 39.2426 37.7426C40.3679 36.6174 41 35.0913 41 33.5V26C41 24.4087 40.3679 22.8826 39.2426 21.7574C38.1174 20.6321 36.5913 20 35 20C33.4087 20 31.8826 20.6321 30.7574 21.7574C29.6321 22.8826 29 24.4087 29 26V33.5C29 35.0913 29.6321 36.6174 30.7574 37.7426C31.8826 38.8679 33.4087 39.5 35 39.5Z"
        fill="white"
      />
      <path
        d="M45.5 33.5C45.5 33.1022 45.342 32.7206 45.0607 32.4393C44.7794 32.158 44.3978 32 44 32C43.6022 32 43.2206 32.158 42.9393 32.4393C42.658 32.7206 42.5 33.1022 42.5 33.5C42.5 35.4891 41.7098 37.3968 40.3033 38.8033C38.8968 40.2098 36.9891 41 35 41C33.0109 41 31.1032 40.2098 29.6967 38.8033C28.2902 37.3968 27.5 35.4891 27.5 33.5C27.5 33.1022 27.342 32.7206 27.0607 32.4393C26.7794 32.158 26.3978 32 26 32C25.6022 32 25.2206 32.158 24.9393 32.4393C24.658 32.7206 24.5 33.1022 24.5 33.5C24.503 36.0228 25.4141 38.4601 27.0668 40.3662C28.7194 42.2723 31.0031 43.5196 33.5 43.88V47H30.335C29.9809 47 29.6414 47.1407 29.391 47.391C29.1407 47.6414 29 47.9809 29 48.335V48.665C29 49.0191 29.1407 49.3586 29.391 49.609C29.6414 49.8593 29.9809 50 30.335 50H39.665C40.0191 50 40.3586 49.8593 40.609 49.609C40.8593 49.3586 41 49.0191 41 48.665V48.335C41 47.9809 40.8593 47.6414 40.609 47.391C40.3586 47.1407 40.0191 47 39.665 47H36.5V43.88C38.9969 43.5196 41.2806 42.2723 42.9332 40.3662C44.5859 38.4601 45.497 36.0228 45.5 33.5Z"
        fill="white"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_400_1340"
        x1={70.2893}
        y1={65.463}
        x2={-19.438}
        y2={48.4167}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#409500" />
        <stop offset={1} stopColor="#84F630" />
      </linearGradient>
      <clipPath id="clip0_400_1340">
        <rect
          width={36}
          height={36}
          fill="white"
          transform="translate(17 17)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const StopButton = (props) => (
  <svg
    width={props.width || 70}
    height={props.height || 70}
    viewBox="0 0 70 70"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={70} height={70} rx={35} fill="url(#paint0_linear_430_15971)" />
    <g clipPath="url(#clip0_430_15971)">
      <path
        d="M34.9994 19.166C31.8678 19.166 28.8066 20.0946 26.2028 21.8344C23.599 23.5742 21.5697 26.047 20.3713 28.9402C19.1729 31.8334 18.8593 35.0169 19.4703 38.0883C20.0812 41.1596 21.5892 43.9809 23.8035 46.1952C26.0178 48.4095 28.8391 49.9175 31.9104 50.5285C34.9818 51.1394 38.1653 50.8258 41.0585 49.6274C43.9517 48.4291 46.4245 46.3997 48.1643 43.7959C49.9041 41.1921 50.8327 38.1309 50.8327 34.9993C50.8327 32.9201 50.4231 30.8612 49.6274 28.9402C48.8318 27.0192 47.6655 25.2738 46.1952 23.8035C44.725 22.3332 42.9795 21.167 41.0585 20.3713C39.1375 19.5756 37.0786 19.166 34.9994 19.166ZM41.3327 39.3535C41.3327 39.8784 41.1242 40.3818 40.753 40.753C40.3818 41.1242 39.8784 41.3327 39.3535 41.3327H30.6452C30.1203 41.3327 29.6169 41.1242 29.2457 40.753C28.8745 40.3818 28.666 39.8784 28.666 39.3535V30.6452C28.666 30.1203 28.8745 29.6169 29.2457 29.2457C29.6169 28.8745 30.1203 28.666 30.6452 28.666H39.3535C39.8784 28.666 40.3818 28.8745 40.753 29.2457C41.1242 29.6169 41.3327 30.1203 41.3327 30.6452V39.3535Z"
        fill="white"
      />
      <path
        d="M40.1327 28.666H29.866C29.2033 28.666 28.666 29.2033 28.666 29.866V40.1327C28.666 40.7954 29.2033 41.3327 29.866 41.3327H40.1327C40.7954 41.3327 41.3327 40.7954 41.3327 40.1327V29.866C41.3327 29.2033 40.7954 28.666 40.1327 28.666Z"
        fill="#FF4B4B"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_430_15971"
        x1={70}
        y1={70}
        x2={11.0949}
        y2={61.1493}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C30303" />
        <stop offset={1} stopColor="#FF5656" />
      </linearGradient>
      <clipPath id="clip0_430_15971">
        <rect
          width={38}
          height={38}
          fill="white"
          transform="translate(16 16)"
        />
      </clipPath>
    </defs>
  </svg>
);

export const AudioPlayerSvg = (props) => {
  return (
    <svg
      width={403}
      height={80}
      viewBox="0 0 403 80"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        opacity={0.15}
        width={403}
        height={80}
        rx={14}
        fill={props?.color || "#A856FF"}
      />
    </svg>
  );
};

export const PlayAudioButton = (props) => (
  <svg
    width={props.size || 48}
    height={props.size || 48}
    viewBox={`0 0 48 48`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 4C20.0444 4 16.1776 5.17298 12.8886 7.37061C9.59962 9.56824 7.03617 12.6918 5.52242 16.3463C4.00867 20.0009 3.6126 24.0222 4.3843 27.9018C5.15601 31.7814 7.06082 35.3451 9.85787 38.1421C12.6549 40.9392 16.2186 42.844 20.0982 43.6157C23.9778 44.3874 27.9992 43.9913 31.6537 42.4776C35.3082 40.9638 38.4318 38.4004 40.6294 35.1114C42.827 31.8224 44 27.9556 44 24C44 21.3736 43.4827 18.7728 42.4776 16.3463C41.4725 13.9198 39.9993 11.715 38.1421 9.85786C36.285 8.00069 34.0802 6.5275 31.6537 5.52241C29.2272 4.51732 26.6264 4 24 4Z"
      fill={props?.color || "#A856FF"}
    />
    <path
      d="M21.2667 34C20.7433 33.9969 20.2264 33.8833 19.75 33.6667C19.2347 33.4396 18.7957 33.069 18.4854 32.5991C18.1751 32.1292 18.0066 31.58 18 31.017V16.985C18.0066 16.422 18.1751 15.8727 18.4854 15.4028C18.7957 14.933 19.2347 14.5624 19.75 14.3352C20.3429 14.0552 21.0026 13.9474 21.6538 14.024C22.305 14.1006 22.9216 14.3586 23.4333 14.7685L31.9333 21.7845C32.2667 22.0499 32.5358 22.3869 32.7209 22.7707C32.9059 23.1544 33.002 23.575 33.002 24.001C33.002 24.427 32.9059 24.8475 32.7209 25.2313C32.5358 25.615 32.2667 25.9521 31.9333 26.2174L23.4333 33.2334C22.8206 33.7302 22.0555 34.0009 21.2667 34Z"
      fill="#F5F5F5"
    />
  </svg>
);

export const StopAudioButton = (props) => (
  <svg
    width={props.size || 48}
    height={props.size || 48}
    viewBox={`0 0 48 48`}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M24 4C20.0444 4 16.1776 5.17298 12.8886 7.37061C9.59962 9.56824 7.03617 12.6918 5.52242 16.3463C4.00867 20.0009 3.6126 24.0222 4.3843 27.9018C5.15601 31.7814 7.06082 35.3451 9.85787 38.1421C12.6549 40.9392 16.2186 42.844 20.0982 43.6157C23.9778 44.3874 27.9992 43.9913 31.6537 42.4776C35.3082 40.9638 38.4318 38.4004 40.6294 35.1114C42.827 31.8224 44 27.9556 44 24C44 21.3736 43.4827 18.7728 42.4776 16.3463C41.4725 13.9198 39.9993 11.715 38.1421 9.85786C36.285 8.00069 34.0802 6.5275 31.6537 5.52241C29.2272 4.51732 26.6264 4 24 4ZM32 29.5C32 30.163 31.7366 30.7989 31.2678 31.2678C30.7989 31.7366 30.1631 32 29.5 32H18.5C17.837 32 17.2011 31.7366 16.7322 31.2678C16.2634 30.7989 16 30.163 16 29.5V18.5C16 17.837 16.2634 17.2011 16.7322 16.7322C17.2011 16.2634 17.837 16 18.5 16H29.5C30.1631 16 30.7989 16.2634 31.2678 16.7322C31.7366 17.2011 32 17.837 32 18.5V29.5Z"
      fill={props?.color || "#A856FF"}
    />
  </svg>
);

export const AudioBarSvg = (props) => (
  <svg
    width={275}
    height={54}
    viewBox="0 0 275 54"
    fill="none"
    opacity={0.3}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M188.45 42.1133C187.464 42.1133 186.666 41.3139 186.666 40.3289V13.008C186.666 12.023 187.464 11.2236 188.45 11.2236C189.435 11.2236 190.235 12.023 190.235 13.008V40.3289C190.235 41.3139 189.435 42.1133 188.45 42.1133Z"
      fill="#A856FF"
    />
    <path
      d="M253.784 42.1133C252.798 42.1133 252 41.3139 252 40.3289V13.008C252 12.023 252.798 11.2236 253.784 11.2236C254.769 11.2236 255.569 12.023 255.569 13.008V40.3289C255.569 41.3139 254.769 42.1133 253.784 42.1133Z"
      fill="#A856FF"
    />
    <path
      d="M179.116 37.8389C178.131 37.8389 177.332 37.0395 177.332 36.0545V17.2795C177.332 16.2945 178.131 15.4951 179.116 15.4951C180.101 15.4951 180.901 16.2945 180.901 17.2795V36.0545C180.901 37.0395 180.101 37.8389 179.116 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M244.45 37.8389C243.465 37.8389 242.666 37.0395 242.666 36.0545V17.2795C242.666 16.2945 243.465 15.4951 244.45 15.4951C245.435 15.4951 246.235 16.2945 246.235 17.2795V36.0545C246.235 37.0395 245.435 37.8389 244.45 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M197.784 37.8389C196.799 37.8389 196 37.0395 196 36.0545V17.2795C196 16.2945 196.799 15.4951 197.784 15.4951C198.769 15.4951 199.569 16.2945 199.569 17.2795V36.0545C199.569 37.0395 198.769 37.8389 197.784 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M263.116 37.8389C262.131 37.8389 261.332 37.0395 261.332 36.0545V17.2795C261.332 16.2945 262.131 15.4951 263.116 15.4951C264.101 15.4951 264.901 16.2945 264.901 17.2795V36.0545C264.901 37.0395 264.101 37.8389 263.116 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M207.116 34.0029C206.131 34.0029 205.332 33.2047 205.332 32.2186V21.1151C205.332 20.1301 206.131 19.3307 207.116 19.3307C208.101 19.3307 208.901 20.1301 208.901 21.1151V32.2186C208.901 33.2047 208.101 34.0029 207.116 34.0029Z"
      fill="#A856FF"
    />
    <path
      d="M272.45 34.0029C271.465 34.0029 270.666 33.2047 270.666 32.2186V21.1151C270.666 20.1301 271.465 19.3307 272.45 19.3307C273.435 19.3307 274.235 20.1301 274.235 21.1151V32.2186C274.235 33.2047 273.435 34.0029 272.45 34.0029Z"
      fill="#A856FF"
    />
    <path
      d="M76.4504 41.6357C75.4654 41.6357 74.666 40.8375 74.666 39.8514V13.4833C74.666 12.4983 75.4654 11.6989 76.4504 11.6989C77.4365 11.6989 78.2347 12.4983 78.2347 13.4833V39.8514C78.2347 40.8375 77.4365 41.6357 76.4504 41.6357Z"
      fill="#A856FF"
    />
    <path
      d="M85.7844 37.3848C84.7994 37.3848 84 36.5854 84 35.6004V17.7342C84 16.7492 84.7994 15.9498 85.7844 15.9498C86.7705 15.9498 87.5687 16.7492 87.5687 17.7342V35.6004C87.5687 36.5854 86.7705 37.3848 85.7844 37.3848Z"
      fill="#A856FF"
    />
    <path
      d="M95.1164 35.1133C94.1302 35.1133 93.332 34.3139 93.332 33.3289V20.0045C93.332 19.0195 94.1302 18.2201 95.1164 18.2201C96.1014 18.2201 96.9008 19.0195 96.9008 20.0045V33.3289C96.9008 34.3139 96.1014 35.1133 95.1164 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M104.45 41.9277C103.464 41.9277 102.666 41.1283 102.666 40.1434V13.1912C102.666 12.2062 103.464 11.4069 104.45 11.4069C105.435 11.4069 106.235 12.2062 106.235 13.1912V40.1434C106.235 41.1283 105.435 41.9277 104.45 41.9277Z"
      fill="#A856FF"
    />
    <path
      d="M141.784 41.9277C140.799 41.9277 140 41.1283 140 40.1434V13.1912C140 12.2062 140.799 11.4069 141.784 11.4069C142.769 11.4069 143.569 12.2062 143.569 13.1912V40.1434C143.569 41.1283 142.769 41.9277 141.784 41.9277Z"
      fill="#A856FF"
    />
    <path
      d="M113.784 46.167C112.799 46.167 112 45.3676 112 44.3826V8.95237C112 7.96741 112.799 7.16801 113.784 7.16801C114.769 7.16801 115.569 7.96741 115.569 8.95237V44.3826C115.569 45.3676 114.769 46.167 113.784 46.167Z"
      fill="#A856FF"
    />
    <path
      d="M123.116 53.333C122.131 53.333 121.332 52.5348 121.332 51.5486V1.78403C121.332 0.799068 122.131 -0.000324249 123.116 -0.000324249C124.103 -0.000324249 124.901 0.799068 124.901 1.78403V51.5486C124.901 52.5348 124.103 53.333 123.116 53.333Z"
      fill="#A856FF"
    />
    <path
      d="M132.45 46.167C131.465 46.167 130.666 45.3676 130.666 44.3826V8.95237C130.666 7.96741 131.465 7.16801 132.45 7.16801C133.435 7.16801 134.235 7.96741 134.235 8.95237V44.3826C134.235 45.3676 133.435 46.167 132.45 46.167Z"
      fill="#A856FF"
    />
    <path
      d="M151.116 35.1133C150.13 35.1133 149.332 34.3139 149.332 33.3289V20.0045C149.332 19.0195 150.13 18.2201 151.116 18.2201C152.101 18.2201 152.901 19.0195 152.901 20.0045V33.3289C152.901 34.3139 152.101 35.1133 151.116 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M216.45 35.1133C215.464 35.1133 214.666 34.3139 214.666 33.3289V20.0045C214.666 19.0195 215.464 18.2201 216.45 18.2201C217.435 18.2201 218.235 19.0195 218.235 20.0045V33.3289C218.235 34.3139 217.435 35.1133 216.45 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M169.784 35.1133C168.799 35.1133 168 34.3139 168 33.3289V20.0045C168 19.0195 168.799 18.2201 169.784 18.2201C170.769 18.2201 171.569 19.0195 171.569 20.0045V33.3289C171.569 34.3139 170.769 35.1133 169.784 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M235.116 35.1133C234.131 35.1133 233.332 34.3139 233.332 33.3289V20.0045C233.332 19.0195 234.131 18.2201 235.116 18.2201C236.101 18.2201 236.901 19.0195 236.901 20.0045V33.3289C236.901 34.3139 236.101 35.1133 235.116 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M160.45 32.8906C159.465 32.8906 158.666 32.0912 158.666 31.1063V22.2297C158.666 21.2447 159.465 20.4453 160.45 20.4453C161.435 20.4453 162.235 21.2447 162.235 22.2297V31.1063C162.235 32.0912 161.435 32.8906 160.45 32.8906Z"
      fill="#A856FF"
    />
    <path
      d="M225.784 32.8906C224.799 32.8906 224 32.0912 224 31.1063V22.2297C224 21.2447 224.799 20.4453 225.784 20.4453C226.769 20.4453 227.569 21.2447 227.569 22.2297V31.1063C227.569 32.0912 226.769 32.8906 225.784 32.8906Z"
      fill="#A856FF"
    />
    <path
      d="M20.4504 42.1133C19.4654 42.1133 18.666 41.3139 18.666 40.3289V13.008C18.666 12.023 19.4654 11.2236 20.4504 11.2236C21.4365 11.2236 22.2347 12.023 22.2347 13.008V40.3289C22.2347 41.3139 21.4365 42.1133 20.4504 42.1133Z"
      fill="#A856FF"
    />
    <path
      d="M11.1183 37.8389C10.1322 37.8389 9.33398 37.0395 9.33398 36.0545V17.2795C9.33398 16.2945 10.1322 15.4951 11.1183 15.4951C12.1045 15.4951 12.9027 16.2945 12.9027 17.2795V36.0545C12.9027 37.0395 12.1045 37.8389 11.1183 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M29.7844 37.8389C28.7982 37.8389 28 37.0395 28 36.0545V17.2795C28 16.2945 28.7982 15.4951 29.7844 15.4951C30.7693 15.4951 31.5687 16.2945 31.5687 17.2795V36.0545C31.5687 37.0395 30.7693 37.8389 29.7844 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M39.1183 34.0029C38.1322 34.0029 37.334 33.2047 37.334 32.2186V21.1151C37.334 20.1301 38.1322 19.3307 39.1183 19.3307C40.1033 19.3307 40.9027 20.1301 40.9027 21.1151V32.2186C40.9027 33.2047 40.1033 34.0029 39.1183 34.0029Z"
      fill="#A856FF"
    />
    <path
      d="M48.4504 37.4854C47.4642 37.4854 46.666 36.686 46.666 35.701V17.6326C46.666 16.6476 47.4642 15.8482 48.4504 15.8482C49.4365 15.8482 50.2347 16.6476 50.2347 17.6326V35.701C50.2347 36.686 49.4365 37.4854 48.4504 37.4854Z"
      fill="#A856FF"
    />
    <path
      d="M57.7844 41.4336C56.7982 41.4336 56 40.6342 56 39.6492V13.6844C56 12.6995 56.7982 11.9001 57.7844 11.9001C58.7693 11.9001 59.5687 12.6995 59.5687 13.6844V39.6492C59.5687 40.6342 58.7693 41.4336 57.7844 41.4336Z"
      fill="#A856FF"
    />
    <path
      d="M67.1183 46.167C66.1322 46.167 65.334 45.3676 65.334 44.3826V8.95237C65.334 7.96741 66.1322 7.16801 67.1183 7.16801C68.1045 7.16801 68.9027 7.96741 68.9027 8.95237V44.3826C68.9027 45.3676 68.1045 46.167 67.1183 46.167Z"
      fill="#A856FF"
    />
    <path
      d="M1.78436 35.1133C0.798204 35.1133 0 34.3139 0 33.3289V20.0045C0 19.0195 0.798204 18.2201 1.78436 18.2201C2.76933 18.2201 3.56872 19.0195 3.56872 20.0045V33.3289C3.56872 34.3139 2.76933 35.1133 1.78436 35.1133Z"
      fill="#A856FF"
    />
  </svg>
);

export const AudioBarColoredSvg = (props) => (
  <svg
    width={props.width}
    height={54}
    viewBox={`0 0 ${props.width} 54`}
    fill="none"
    opacity={1}
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M188.45 42.1133C187.464 42.1133 186.666 41.3139 186.666 40.3289V13.008C186.666 12.023 187.464 11.2236 188.45 11.2236C189.435 11.2236 190.235 12.023 190.235 13.008V40.3289C190.235 41.3139 189.435 42.1133 188.45 42.1133Z"
      fill="#A856FF"
    />
    <path
      d="M253.784 42.1133C252.798 42.1133 252 41.3139 252 40.3289V13.008C252 12.023 252.798 11.2236 253.784 11.2236C254.769 11.2236 255.569 12.023 255.569 13.008V40.3289C255.569 41.3139 254.769 42.1133 253.784 42.1133Z"
      fill="#A856FF"
    />
    <path
      d="M179.116 37.8389C178.131 37.8389 177.332 37.0395 177.332 36.0545V17.2795C177.332 16.2945 178.131 15.4951 179.116 15.4951C180.101 15.4951 180.901 16.2945 180.901 17.2795V36.0545C180.901 37.0395 180.101 37.8389 179.116 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M244.45 37.8389C243.465 37.8389 242.666 37.0395 242.666 36.0545V17.2795C242.666 16.2945 243.465 15.4951 244.45 15.4951C245.435 15.4951 246.235 16.2945 246.235 17.2795V36.0545C246.235 37.0395 245.435 37.8389 244.45 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M197.784 37.8389C196.799 37.8389 196 37.0395 196 36.0545V17.2795C196 16.2945 196.799 15.4951 197.784 15.4951C198.769 15.4951 199.569 16.2945 199.569 17.2795V36.0545C199.569 37.0395 198.769 37.8389 197.784 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M263.116 37.8389C262.131 37.8389 261.332 37.0395 261.332 36.0545V17.2795C261.332 16.2945 262.131 15.4951 263.116 15.4951C264.101 15.4951 264.901 16.2945 264.901 17.2795V36.0545C264.901 37.0395 264.101 37.8389 263.116 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M207.116 34.0029C206.131 34.0029 205.332 33.2047 205.332 32.2186V21.1151C205.332 20.1301 206.131 19.3307 207.116 19.3307C208.101 19.3307 208.901 20.1301 208.901 21.1151V32.2186C208.901 33.2047 208.101 34.0029 207.116 34.0029Z"
      fill="#A856FF"
    />
    <path
      d="M272.45 34.0029C271.465 34.0029 270.666 33.2047 270.666 32.2186V21.1151C270.666 20.1301 271.465 19.3307 272.45 19.3307C273.435 19.3307 274.235 20.1301 274.235 21.1151V32.2186C274.235 33.2047 273.435 34.0029 272.45 34.0029Z"
      fill="#A856FF"
    />
    <path
      d="M76.4504 41.6357C75.4654 41.6357 74.666 40.8375 74.666 39.8514V13.4833C74.666 12.4983 75.4654 11.6989 76.4504 11.6989C77.4365 11.6989 78.2347 12.4983 78.2347 13.4833V39.8514C78.2347 40.8375 77.4365 41.6357 76.4504 41.6357Z"
      fill="#A856FF"
    />
    <path
      d="M85.7844 37.3848C84.7994 37.3848 84 36.5854 84 35.6004V17.7342C84 16.7492 84.7994 15.9498 85.7844 15.9498C86.7705 15.9498 87.5687 16.7492 87.5687 17.7342V35.6004C87.5687 36.5854 86.7705 37.3848 85.7844 37.3848Z"
      fill="#A856FF"
    />
    <path
      d="M95.1164 35.1133C94.1302 35.1133 93.332 34.3139 93.332 33.3289V20.0045C93.332 19.0195 94.1302 18.2201 95.1164 18.2201C96.1014 18.2201 96.9008 19.0195 96.9008 20.0045V33.3289C96.9008 34.3139 96.1014 35.1133 95.1164 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M104.45 41.9277C103.464 41.9277 102.666 41.1283 102.666 40.1434V13.1912C102.666 12.2062 103.464 11.4069 104.45 11.4069C105.435 11.4069 106.235 12.2062 106.235 13.1912V40.1434C106.235 41.1283 105.435 41.9277 104.45 41.9277Z"
      fill="#A856FF"
    />
    <path
      d="M141.784 41.9277C140.799 41.9277 140 41.1283 140 40.1434V13.1912C140 12.2062 140.799 11.4069 141.784 11.4069C142.769 11.4069 143.569 12.2062 143.569 13.1912V40.1434C143.569 41.1283 142.769 41.9277 141.784 41.9277Z"
      fill="#A856FF"
    />
    <path
      d="M113.784 46.167C112.799 46.167 112 45.3676 112 44.3826V8.95237C112 7.96741 112.799 7.16801 113.784 7.16801C114.769 7.16801 115.569 7.96741 115.569 8.95237V44.3826C115.569 45.3676 114.769 46.167 113.784 46.167Z"
      fill="#A856FF"
    />
    <path
      d="M123.116 53.333C122.131 53.333 121.332 52.5348 121.332 51.5486V1.78403C121.332 0.799068 122.131 -0.000324249 123.116 -0.000324249C124.103 -0.000324249 124.901 0.799068 124.901 1.78403V51.5486C124.901 52.5348 124.103 53.333 123.116 53.333Z"
      fill="#A856FF"
    />
    <path
      d="M132.45 46.167C131.465 46.167 130.666 45.3676 130.666 44.3826V8.95237C130.666 7.96741 131.465 7.16801 132.45 7.16801C133.435 7.16801 134.235 7.96741 134.235 8.95237V44.3826C134.235 45.3676 133.435 46.167 132.45 46.167Z"
      fill="#A856FF"
    />
    <path
      d="M151.116 35.1133C150.13 35.1133 149.332 34.3139 149.332 33.3289V20.0045C149.332 19.0195 150.13 18.2201 151.116 18.2201C152.101 18.2201 152.901 19.0195 152.901 20.0045V33.3289C152.901 34.3139 152.101 35.1133 151.116 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M216.45 35.1133C215.464 35.1133 214.666 34.3139 214.666 33.3289V20.0045C214.666 19.0195 215.464 18.2201 216.45 18.2201C217.435 18.2201 218.235 19.0195 218.235 20.0045V33.3289C218.235 34.3139 217.435 35.1133 216.45 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M169.784 35.1133C168.799 35.1133 168 34.3139 168 33.3289V20.0045C168 19.0195 168.799 18.2201 169.784 18.2201C170.769 18.2201 171.569 19.0195 171.569 20.0045V33.3289C171.569 34.3139 170.769 35.1133 169.784 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M235.116 35.1133C234.131 35.1133 233.332 34.3139 233.332 33.3289V20.0045C233.332 19.0195 234.131 18.2201 235.116 18.2201C236.101 18.2201 236.901 19.0195 236.901 20.0045V33.3289C236.901 34.3139 236.101 35.1133 235.116 35.1133Z"
      fill="#A856FF"
    />
    <path
      d="M160.45 32.8906C159.465 32.8906 158.666 32.0912 158.666 31.1063V22.2297C158.666 21.2447 159.465 20.4453 160.45 20.4453C161.435 20.4453 162.235 21.2447 162.235 22.2297V31.1063C162.235 32.0912 161.435 32.8906 160.45 32.8906Z"
      fill="#A856FF"
    />
    <path
      d="M225.784 32.8906C224.799 32.8906 224 32.0912 224 31.1063V22.2297C224 21.2447 224.799 20.4453 225.784 20.4453C226.769 20.4453 227.569 21.2447 227.569 22.2297V31.1063C227.569 32.0912 226.769 32.8906 225.784 32.8906Z"
      fill="#A856FF"
    />
    <path
      d="M20.4504 42.1133C19.4654 42.1133 18.666 41.3139 18.666 40.3289V13.008C18.666 12.023 19.4654 11.2236 20.4504 11.2236C21.4365 11.2236 22.2347 12.023 22.2347 13.008V40.3289C22.2347 41.3139 21.4365 42.1133 20.4504 42.1133Z"
      fill="#A856FF"
    />
    <path
      d="M11.1183 37.8389C10.1322 37.8389 9.33398 37.0395 9.33398 36.0545V17.2795C9.33398 16.2945 10.1322 15.4951 11.1183 15.4951C12.1045 15.4951 12.9027 16.2945 12.9027 17.2795V36.0545C12.9027 37.0395 12.1045 37.8389 11.1183 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M29.7844 37.8389C28.7982 37.8389 28 37.0395 28 36.0545V17.2795C28 16.2945 28.7982 15.4951 29.7844 15.4951C30.7693 15.4951 31.5687 16.2945 31.5687 17.2795V36.0545C31.5687 37.0395 30.7693 37.8389 29.7844 37.8389Z"
      fill="#A856FF"
    />
    <path
      d="M39.1183 34.0029C38.1322 34.0029 37.334 33.2047 37.334 32.2186V21.1151C37.334 20.1301 38.1322 19.3307 39.1183 19.3307C40.1033 19.3307 40.9027 20.1301 40.9027 21.1151V32.2186C40.9027 33.2047 40.1033 34.0029 39.1183 34.0029Z"
      fill="#A856FF"
    />
    <path
      d="M48.4504 37.4854C47.4642 37.4854 46.666 36.686 46.666 35.701V17.6326C46.666 16.6476 47.4642 15.8482 48.4504 15.8482C49.4365 15.8482 50.2347 16.6476 50.2347 17.6326V35.701C50.2347 36.686 49.4365 37.4854 48.4504 37.4854Z"
      fill="#A856FF"
    />
    <path
      d="M57.7844 41.4336C56.7982 41.4336 56 40.6342 56 39.6492V13.6844C56 12.6995 56.7982 11.9001 57.7844 11.9001C58.7693 11.9001 59.5687 12.6995 59.5687 13.6844V39.6492C59.5687 40.6342 58.7693 41.4336 57.7844 41.4336Z"
      fill="#A856FF"
    />
    <path
      d="M67.1183 46.167C66.1322 46.167 65.334 45.3676 65.334 44.3826V8.95237C65.334 7.96741 66.1322 7.16801 67.1183 7.16801C68.1045 7.16801 68.9027 7.96741 68.9027 8.95237V44.3826C68.9027 45.3676 68.1045 46.167 67.1183 46.167Z"
      fill="#A856FF"
    />
    <path
      d="M1.78436 35.1133C0.798204 35.1133 0 34.3139 0 33.3289V20.0045C0 19.0195 0.798204 18.2201 1.78436 18.2201C2.76933 18.2201 3.56872 19.0195 3.56872 20.0045V33.3289C3.56872 34.3139 2.76933 35.1133 1.78436 35.1133Z"
      fill="#A856FF"
    />
  </svg>
);

export const SubmitButton = (props) => (
  <svg
    width={115}
    height={54}
    viewBox="0 0 115 54"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <rect width={115} height={54} rx={10} fill="url(#paint0_linear_82_59530)" />
    <path
      d="M29.92 35.2C28.96 35.2 28.1067 35.0667 27.36 34.8C26.6133 34.5333 25.9 34.0933 25.22 33.48C25.0733 33.3733 24.96 33.2467 24.88 33.1C24.8133 32.94 24.78 32.78 24.78 32.62C24.78 32.3667 24.8733 32.14 25.06 31.94C25.2467 31.74 25.48 31.64 25.76 31.64C25.9733 31.64 26.1733 31.7133 26.36 31.86C26.8667 32.3267 27.3933 32.68 27.94 32.92C28.5 33.16 29.1533 33.28 29.9 33.28C30.4333 33.28 30.92 33.1933 31.36 33.02C31.8133 32.8467 32.1733 32.6133 32.44 32.32C32.7067 32.0267 32.84 31.6867 32.84 31.3C32.84 30.82 32.7 30.4267 32.42 30.12C32.1533 29.8 31.76 29.54 31.24 29.34C30.7333 29.1267 30.12 28.9467 29.4 28.8C28.7333 28.68 28.1333 28.5133 27.6 28.3C27.08 28.0867 26.6333 27.82 26.26 27.5C25.8867 27.1667 25.6 26.7733 25.4 26.32C25.2 25.8667 25.1 25.34 25.1 24.74C25.1 23.9267 25.3133 23.2267 25.74 22.64C26.1667 22.0533 26.7467 21.6 27.48 21.28C28.2133 20.96 29.04 20.8 29.96 20.8C30.8 20.8 31.5867 20.9333 32.32 21.2C33.0533 21.4533 33.6467 21.8 34.1 22.24C34.42 22.52 34.58 22.82 34.58 23.14C34.58 23.38 34.48 23.6067 34.28 23.82C34.0933 24.02 33.8733 24.12 33.62 24.12C33.4333 24.12 33.2733 24.0667 33.14 23.96C32.9267 23.7333 32.64 23.5333 32.28 23.36C31.92 23.1733 31.5333 23.02 31.12 22.9C30.72 22.78 30.3333 22.72 29.96 22.72C29.36 22.72 28.8467 22.8067 28.42 22.98C27.9933 23.14 27.6667 23.3667 27.44 23.66C27.2133 23.94 27.1 24.2733 27.1 24.66C27.1 25.1133 27.2267 25.4867 27.48 25.78C27.7467 26.0733 28.1133 26.3133 28.58 26.5C29.0467 26.6733 29.58 26.8333 30.18 26.98C30.9133 27.14 31.5667 27.32 32.14 27.52C32.7267 27.72 33.22 27.98 33.62 28.3C34.02 28.6067 34.3267 28.9933 34.54 29.46C34.7533 29.9267 34.86 30.5067 34.86 31.2C34.86 32 34.6333 32.7 34.18 33.3C33.7267 33.9 33.1267 34.3667 32.38 34.7C31.6467 35.0333 30.8267 35.2 29.92 35.2ZM44.9392 24.48C45.2192 24.48 45.4526 24.58 45.6392 24.78C45.8392 24.9667 45.9392 25.2067 45.9392 25.5V30.76C45.9392 32.1467 45.5526 33.2333 44.7792 34.02C44.0059 34.7933 42.9126 35.18 41.4992 35.18C40.0992 35.18 39.0126 34.7933 38.2392 34.02C37.4792 33.2333 37.0992 32.1467 37.0992 30.76V25.5C37.0992 25.2067 37.1926 24.9667 37.3792 24.78C37.5659 24.58 37.8059 24.48 38.0992 24.48C38.3792 24.48 38.6126 24.58 38.7992 24.78C38.9992 24.9667 39.0992 25.2067 39.0992 25.5V30.76C39.0992 31.6267 39.2992 32.2733 39.6992 32.7C40.1126 33.1267 40.7126 33.34 41.4992 33.34C42.2992 33.34 42.9059 33.1267 43.3192 32.7C43.7326 32.2733 43.9392 31.6267 43.9392 30.76V25.5C43.9392 25.2067 44.0326 24.9667 44.2192 24.78C44.4059 24.58 44.6459 24.48 44.9392 24.48ZM54.0203 24.24C54.9536 24.24 55.7803 24.4733 56.5003 24.94C57.2336 25.4067 57.8136 26.0533 58.2403 26.88C58.667 27.6933 58.8803 28.6333 58.8803 29.7C58.8803 30.7667 58.667 31.7133 58.2403 32.54C57.8136 33.3667 57.2403 34.02 56.5203 34.5C55.8003 34.9667 54.987 35.2 54.0803 35.2C53.5736 35.2 53.0936 35.12 52.6403 34.96C52.187 34.7867 51.787 34.5733 51.4403 34.32C51.0936 34.0533 50.807 33.7733 50.5803 33.48C50.367 33.1867 50.2336 32.9133 50.1803 32.66L50.7203 32.4V34.14C50.7203 34.42 50.6203 34.66 50.4203 34.86C50.2336 35.0467 50.0003 35.14 49.7203 35.14C49.427 35.14 49.187 35.0467 49.0003 34.86C48.8136 34.6733 48.7203 34.4333 48.7203 34.14V21.22C48.7203 20.9267 48.8136 20.6867 49.0003 20.5C49.187 20.3 49.427 20.2 49.7203 20.2C50.0003 20.2 50.2336 20.3 50.4203 20.5C50.6203 20.6867 50.7203 20.9267 50.7203 21.22V26.84L50.4003 26.66C50.4403 26.4067 50.567 26.1467 50.7803 25.88C50.9936 25.6 51.2603 25.3333 51.5803 25.08C51.9136 24.8267 52.287 24.6267 52.7003 24.48C53.127 24.32 53.567 24.24 54.0203 24.24ZM53.8003 26.08C53.1603 26.08 52.6003 26.24 52.1203 26.56C51.6536 26.88 51.287 27.3133 51.0203 27.86C50.7536 28.3933 50.6203 29.0067 50.6203 29.7C50.6203 30.3933 50.7536 31.02 51.0203 31.58C51.287 32.1267 51.6536 32.56 52.1203 32.88C52.6003 33.2 53.1603 33.36 53.8003 33.36C54.427 33.36 54.9736 33.2 55.4403 32.88C55.907 32.56 56.2736 32.12 56.5403 31.56C56.8203 31 56.9603 30.38 56.9603 29.7C56.9603 29.0067 56.8203 28.3933 56.5403 27.86C56.2736 27.3133 55.907 26.88 55.4403 26.56C54.9736 26.24 54.427 26.08 53.8003 26.08ZM66.4222 24.3C67.4089 24.3 68.1689 24.5467 68.7022 25.04C69.2355 25.52 69.5889 26.1733 69.7622 27L69.4422 26.9L69.5822 26.58C69.7555 26.2333 70.0155 25.8867 70.3622 25.54C70.7222 25.18 71.1489 24.8867 71.6422 24.66C72.1355 24.42 72.6622 24.3 73.2222 24.3C74.1422 24.3 74.8555 24.5 75.3622 24.9C75.8689 25.2867 76.2222 25.8133 76.4222 26.48C76.6222 27.1333 76.7222 27.8667 76.7222 28.68V33.98C76.7222 34.2733 76.6289 34.52 76.4422 34.72C76.2555 34.9067 76.0155 35 75.7222 35C75.4422 35 75.2022 34.9067 75.0022 34.72C74.8155 34.52 74.7222 34.2733 74.7222 33.98V28.7C74.7222 28.2333 74.6555 27.8067 74.5222 27.42C74.4022 27.0333 74.1822 26.7267 73.8622 26.5C73.5555 26.26 73.1289 26.14 72.5822 26.14C72.0622 26.14 71.5955 26.26 71.1822 26.5C70.7822 26.7267 70.4689 27.0333 70.2422 27.42C70.0155 27.8067 69.9022 28.2333 69.9022 28.7V33.98C69.9022 34.2733 69.8089 34.52 69.6222 34.72C69.4355 34.9067 69.1955 35 68.9022 35C68.6089 35 68.3689 34.9067 68.1822 34.72C67.9955 34.52 67.9022 34.2733 67.9022 33.98V28.68C67.9022 28.2133 67.8355 27.7867 67.7022 27.4C67.5822 27.0133 67.3689 26.7067 67.0622 26.48C66.7555 26.2533 66.3289 26.14 65.7822 26.14C65.2622 26.14 64.8022 26.2533 64.4022 26.48C64.0022 26.7067 63.6889 27.0133 63.4622 27.4C63.2489 27.7867 63.1422 28.2133 63.1422 28.68V33.98C63.1422 34.2733 63.0422 34.52 62.8422 34.72C62.6555 34.9067 62.4222 35 62.1422 35C61.8489 35 61.6089 34.9067 61.4222 34.72C61.2355 34.52 61.1422 34.2733 61.1422 33.98V25.5C61.1422 25.2067 61.2355 24.9667 61.4222 24.78C61.6089 24.58 61.8489 24.48 62.1422 24.48C62.4222 24.48 62.6555 24.58 62.8422 24.78C63.0422 24.9667 63.1422 25.2067 63.1422 25.5V26.68L62.7622 26.9C62.8555 26.6067 63.0089 26.3067 63.2222 26C63.4355 25.6933 63.7022 25.4133 64.0222 25.16C64.3555 24.9067 64.7222 24.7 65.1222 24.54C65.5222 24.38 65.9555 24.3 66.4222 24.3ZM81.4011 33.98C81.4011 34.2733 81.3078 34.52 81.1211 34.72C80.9344 34.9067 80.6944 35 80.4011 35C80.1211 35 79.8811 34.9067 79.6811 34.72C79.4944 34.52 79.4011 34.2733 79.4011 33.98V25.42C79.4011 25.1267 79.4944 24.8867 79.6811 24.7C79.8811 24.5 80.1211 24.4 80.4011 24.4C80.6944 24.4 80.9344 24.5 81.1211 24.7C81.3078 24.8867 81.4011 25.1267 81.4011 25.42V33.98ZM80.3811 23.08C79.9944 23.08 79.7144 23.0133 79.5411 22.88C79.3678 22.7333 79.2811 22.4933 79.2811 22.16V21.84C79.2811 21.5067 79.3744 21.2733 79.5611 21.14C79.7478 21.0067 80.0278 20.94 80.4011 20.94C80.8011 20.94 81.0878 21.0133 81.2611 21.16C81.4344 21.2933 81.5211 21.52 81.5211 21.84V22.16C81.5211 22.5067 81.4278 22.7467 81.2411 22.88C81.0678 23.0133 80.7811 23.08 80.3811 23.08ZM83.9514 24.6H88.6514C88.9181 24.6 89.1381 24.6933 89.3114 24.88C89.4981 25.0533 89.5914 25.2733 89.5914 25.54C89.5914 25.7933 89.4981 26.0067 89.3114 26.18C89.1381 26.3533 88.9181 26.44 88.6514 26.44H83.9514C83.6847 26.44 83.4581 26.3533 83.2714 26.18C83.0981 25.9933 83.0114 25.7733 83.0114 25.52C83.0114 25.2533 83.0981 25.0333 83.2714 24.86C83.4581 24.6867 83.6847 24.6 83.9514 24.6ZM86.0514 22C86.3447 22 86.5847 22.1 86.7714 22.3C86.9581 22.4867 87.0514 22.7267 87.0514 23.02V32.3C87.0514 32.54 87.0914 32.7333 87.1714 32.88C87.2514 33.0267 87.3581 33.1267 87.4914 33.18C87.6381 33.2333 87.7847 33.26 87.9314 33.26C88.0781 33.26 88.2047 33.2333 88.3114 33.18C88.4314 33.1267 88.5714 33.1 88.7314 33.1C88.8914 33.1 89.0381 33.1733 89.1714 33.32C89.3047 33.4667 89.3714 33.6667 89.3714 33.92C89.3714 34.24 89.1981 34.5 88.8514 34.7C88.5047 34.9 88.1314 35 87.7314 35C87.5047 35 87.2381 34.98 86.9314 34.94C86.6247 34.9 86.3247 34.8 86.0314 34.64C85.7514 34.48 85.5181 34.2267 85.3314 33.88C85.1447 33.52 85.0514 33.02 85.0514 32.38V23.02C85.0514 22.7267 85.1447 22.4867 85.3314 22.3C85.5314 22.1 85.7714 22 86.0514 22Z"
      fill="white"
    />
    <defs>
      <linearGradient
        id="paint0_linear_82_59530"
        x1={115}
        y1={54}
        x2={14.1964}
        y2={21.1216}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C20281" />
        <stop offset={1} stopColor="#FF4BC2" />
      </linearGradient>
    </defs>
  </svg>
);

// LevelBeginner removed — was dead code (never used)

// SVG icon components extracted to src/components/Icons/SvgIcons.jsx

export function getParameter(key, location) {
  if (key) {
    const query = new URLSearchParams(location);
    return query.get(key);
  }
}

export const SessionID = "13900744731701973109305";
export const UserID = "1390074473";

export const practiceSteps = [
  {
    name: "P1",
    fullName: "Practice 1",
    fullNameMOne: "Learn 1",
    fullNameMTwo: "Learn 1",
    fullNameMThree: "Learn 1", // M3 L1: Phrase Reading
    title: "L1",
    titleNew: "L1",
    titleThree: "L1", // Changed from "P1" to "L1" for correct sequence
  },
  {
    name: "P2",
    fullName: "Practice 2",
    fullNameMOne: "Learn 2",
    fullNameMTwo: "Learn 2",
    fullNameMThree: "Learn 2", // M3 P1: Repeat Phrase
    title: "L2",
    titleNew: "L2",
    titleThree: "P1", // Changed from "L1" to "P1" for correct sequence
  },
  {
    name: "P3",
    fullName: "Practice 3",
    fullNameMOne: "Practice 1",
    fullNameMTwo: "Practice 1",
    fullNameMThree: "Practice 1", // M3 P2: Correct Image Phrase
    title: "P1",
    titleNew: "P1",
    titleThree: "P2", // Changed from "L2" to "P2" for correct sequence
  },
  {
    name: "P4",
    fullName: "Practice 4",
    fullNameMOne: "Practice 2",
    fullNameMTwo: "Practice 2",
    fullNameMThree: "Practice 2", // M3 L2: Phrase Reading
    title: "P2",
    titleNew: "P2",
    titleThree: "L2", // Changed from "P2" to "L2" for correct sequence
  },
  {
    name: "S1",
    fullName: "Showcase 1",
    fullNameMOne: "Showcase 1",
    fullNameMTwo: "Showcase 1",
    fullNameMThree: "Phrase Reading", // M3 S1: Phrase Reading
    title: "S1",
    titleNew: "S1",
    titleThree: "S1",
  },
  {
    name: "P5",
    fullName: "Practice 5",
    fullNameMOne: "Learn 3",
    fullNameMTwo: "Learn 3",
    fullNameMThree: "Learn 3", // M3 L3: Repeat Phrase
    title: "L3",
    titleNew: "L3",
    titleThree: "L3",
  },
  {
    name: "P6",
    fullName: "Practice 6",
    fullNameMOne: "Learn 4",
    fullNameMTwo: "Learn 4",
    fullNameMThree: "Learn 4", // M3 P3: Phrase Reading
    title: "L4",
    titleNew: "L4",
    titleThree: "P3",
  },
  {
    name: "P7",
    fullName: "Practice 7",
    fullNameMOne: "Practice 3",
    fullNameMTwo: "Practice 3",
    fullNameMThree: "Practice 3", // M3 L4: Correct Image Phrase
    title: "P3",
    titleNew: "P3",
    titleThree: "L4",
  },
  {
    name: "P8",
    fullName: "Practice 8",
    fullNameMOne: "Practice 4",
    fullNameMTwo: "Practice 4",
    fullNameMThree: "Practice 4", // M3 P4: Phrase Reading
    title: "P4",
    titleNew: "P4",
    titleThree: "P4",
  },
  {
    name: "S2",
    fullName: "Showcase 2",
    fullNameMOne: "Showcase 2",
    fullNameMTwo: "Showcase 2",
    fullNameMThree: "Phrase Reading", // M3 S2: Phrase Reading
    title: "S2",
    titleNew: "S2",
    titleThree: "S2",
  },
];

// levelGetContent extracted to src/data/levelContent.js
export { levelGetContent } from "../data/levelContent";

export function callConfettiSnow() {
  var duration = 3 * 1000;
  var animationEnd = Date.now() + duration;
  // var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

  // function randomInRange(min, max) {
  //   return Math.random() * (max - min) + min;
  // }

  var interval = setInterval(function () {
    var timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    // since particles fall down, start a bit higher than random
    timeLeft = animationEnd - Date.now();
    var ticks = Math.max(200, 500 * (timeLeft / duration));
    var skew;
    skew = Math.max(0.8, skew - 0.001);

    confetti({
      particleCount: 1,
      startVelocity: 0,
      ticks: ticks,
      origin: {
        x: Math.random(),
        // since particles fall down, skew start toward the top
        y: Math.random() * skew - 0.2,
      },
      colors: ["#3298D6"],
      shapes: ["circle"],
    });
  }, 250);
}

export const callConfetti = () => {
  var duration = 3 * 1000;
  var animationEnd = Date.now() + duration;
  var defaults = { startVelocity: 30, spread: 360, ticks: 60, zIndex: 0 };

  function randomInRange(min, max) {
    return Math.random() * (max - min) + min;
  }

  var interval = setInterval(function () {
    var timeLeft = animationEnd - Date.now();

    if (timeLeft <= 0) {
      return clearInterval(interval);
    }

    var particleCount = 50 * (timeLeft / duration);
    // since particles fall down, start a bit higher than random
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.1, 0.3), y: Math.random() - 0.2 },
    });
    confetti({
      ...defaults,
      particleCount,
      origin: { x: randomInRange(0.7, 0.9), y: Math.random() - 0.2 },
    });
  }, 250);
};

export const levelConfig = {
  B: { color: "#3872C1" },
  1: { color: "#3872C1" },
  2: { color: "#FF1276" },
  3: { color: "#FFB31F" },
  4: { color: "#BC00FF" },
  5: { color: "#37C473" },
  6: { color: "#F810E1" },
  7: { color: "#634AFF" },
  8: { color: "#B4CF12" },
  9: { color: "#00C7E2" },
  10: { color: "#00C7E2" },
  11: { color: "#00C7E2" },
  12: { color: "#00C7E2" },
  13: { color: "#00C7E2" },
  14: { color: "#00C7E2" },
  15: { color: "#00C7E2" },
};

const AllLanguages = [
  { name: "English", lang: "en", symbol: "A" },
  { name: "தமிழ்", lang: "ta", symbol: "இ" },
  { name: "हिंदी", lang: "hi", symbol: "क" },
  { name: "ಕನ್ನಡ", lang: "kn", symbol: "ಕ" },
  { name: "తెలుగు", lang: "te", symbol: "ఈ" },
  { name: "ગુજરાતી", lang: "gu", symbol: "ક" },
  { name: "ଓଡିଆ", lang: "or", symbol: "କ" },
];

const appLanguages = process.env.REACT_APP_LANGUAGES
  ? JSON.parse(process.env.REACT_APP_LANGUAGES)
  : [];

export const languages = AllLanguages.filter((lang) =>
  appLanguages.includes(lang.lang)
);

// Get default language from environment variable, fallback to "en"
export const getDefaultLanguage = () => {
  return process.env.REACT_APP_LANGUAGE || "en";
};

// Get language from localStorage or use default from environment variable
export const getLanguageOrDefault = () => {
  return getLocalData("lang") || getDefaultLanguage();
};

export const randomizeArray = (arr) => {
  let wordsArr = [...arr];
  for (let i = wordsArr.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * i);
    let k = wordsArr[i];
    wordsArr[i] = wordsArr[j];
    wordsArr[j] = k;
  }
  return wordsArr;
};

export function handleEncrypt(value) {
  const API_SECRET_KEY = localStorage.getItem("apiToken");
  if (!API_SECRET_KEY) return null;
  try {
    var ciphertext = CryptoJS.AES.encrypt(
      JSON.stringify(value),
      API_SECRET_KEY
    ).toString();
    return ciphertext;
  } catch (error) {
    console.error("Crypto operation failed:", error.message);
    return null;
  }
}

export function handleDecrypt(value) {
  const API_SECRET_KEY = localStorage.getItem("apiToken");
  if (!API_SECRET_KEY) return null;
  try {
    var bytes = CryptoJS.AES.decrypt(value, API_SECRET_KEY);
    var decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  } catch (error) {
    console.error("Crypto operation failed:", error.message);
    return null;
  }
}

export const sendTestRigScore = (score) => {
  if (process.env.REACT_APP_IS_APP_IFRAME === "true") {
    window.parent.postMessage(
      {
        score,
        message: "all-test-rig-score",
      },
      window?.location?.ancestorOrigins?.[0] || window.parent.location.origin
    );
  }
};

export function isRecommendationApiEnabledForLang(lang) {
  if (process.env.REACT_APP_USE_RECOMMENDATION_API !== "true") return false;
  const languages = process.env.REACT_APP_RECOMMENDATION_API_LANGUAGES;

  if (!languages || languages === "null") {
    console.error("Recommendation language list missing, using default flow");
    return false;
  }
  const code = String(lang ?? "")
    .trim()
    .toLowerCase();
  if (!code) return false;
  const raw = JSON.parse(languages);
  const allowed =
    raw == null || String(raw).trim() === ""
      ? ["en"]
      : String(raw)
          .split(",")
          .map((s) => s.trim().toLowerCase())
          .filter(Boolean);
  return allowed.includes(code);
}
